import type { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import DataTableOrgPluginsTab from '@/pages/dashboard/tabs/DataTableOrgPluginsTab';

/**
 * Plugins tab for the organization view.
 * Delegates to DataTableOrgPluginsTab which provides filtering,
 * sorting, search, and pagination via the shared DataTable component.
 *
 * The `key={organizationId}` forces a full remount when the user navigates
 * between organizations — without it, non-URL-persisted DataTable state
 * (expanded rows, internal pagination) would leak across orgs.
 */
export default function PluginsTab(): ReactElement | null {
  const { organizationId } = useParams<{ organizationId: string }>();

  if (!organizationId) {
    return null;
  }

  return (
    <DataTableOrgPluginsTab
      key={organizationId}
      organizationId={organizationId}
    />
  );
}
